import * as Sentry from "@sentry/react";
import axios from "axios";
import { useEffect, useState } from "react";

import { APIEndpoints } from "@/apis/endpoints";
import {
  MAILER_APP,
  OFFICE_CONTROLLER_APP,
  USER_SYNC_APP,
} from "@/pages/general-settings/Office/Consent";

export interface OfficeConsent {
  userSync: boolean;
  mailer: boolean;
  officeController: boolean;
}

export interface OfficeSecretNonce {
  UserSync: string;
  Mailer: string;
  OfficeController: string;
}

interface OfficeStatus {
  consent: OfficeConsent;
  secretNonce: OfficeSecretNonce;
}

export function useRetrieveOfficeStatus(): OfficeStatus {
  const [consent, setConsent] = useState<OfficeConsent>({
    userSync: undefined,
    mailer: undefined,
    officeController: undefined,
  });
  const [secretNonce, setSecretNonce] = useState<OfficeSecretNonce>({
    UserSync: null,
    Mailer: null,
    OfficeController: null,
  });

  useEffect(() => {
    const retrieveOfficeConsentStatus = async () => {
      try {
        const response = await axios.get(
          APIEndpoints.SIMULATION + "/users/sync/office/consent_status",
        );
        const allowedApps = response.data.apps || [];
        setSecretNonce(
          response.data.nonces || {
            UserSync: null,
            Mailer: null,
            OfficeController: null,
          },
        );
        setConsent({
          userSync: allowedApps.includes(USER_SYNC_APP.name),
          mailer: allowedApps.includes(MAILER_APP.name),
          officeController: allowedApps.includes(OFFICE_CONTROLLER_APP.name),
        });
      } catch (error) {
        Sentry.captureException(error);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    retrieveOfficeConsentStatus();
    const id = setInterval(() => retrieveOfficeConsentStatus(), 3000); // Run every 3 seconds

    return () => clearInterval(id);
  }, []);

  return { consent, secretNonce };
}
